import React from "react";
import { QuickTestSuccessContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import queryString from "query-string";
import { MyPointWidget } from "widgets";
import { withTranslation } from "react-i18next";
import { Buttons, Displays, Headers, Navigations } from "components";

class QuickTestSuccessContainer extends React.Component {
  handleClickBack = () => {
    this.props.router.navigate(`${ROUTE_PATH.SPECIAL_POINTS_FAV}`);
  };

  render() {
    const { t } = this.props;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Survey", { ns: "common" }),
      },
    ];
    let { point } = queryString.parse(this.props.router.location.search);
    return (
      <QuickTestSuccessContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <Headers.Logo nodeRight={<MyPointWidget />} />
        <div className="success_container">
          <Headers.NewPageHeader
            title={"Special Points"}
            sub_title={"แบบสอบถาม"}
          />
          <div className="status_wrap">
            <Displays.AlertLabel
              label={[
                "ขอบคุณที่แสดงความคิดเห็น",
                `คุณได้รับ ${point || 0} แต้ม`,
              ]}
            />
          </div>
          <div className="btn_wrap">
            <Buttons.BgStandard
              theme_white_purple
              label={t("Back", { ns: "common" })}
              onClick={this.handleClickBack}
            />
          </div>
        </div>
      </QuickTestSuccessContainerStyled>
    );
  }
}

export default withTranslation(["common"])(
  withRouter(QuickTestSuccessContainer),
);
